import { initializeApp, type FirebaseApp } from 'firebase/app'
import { getAuth, connectAuthEmulator, setPersistence, browserLocalPersistence, type Auth } from 'firebase/auth'

// Check if we're in dev bypass mode - skip Firebase entirely
const isDevBypass = import.meta.env.VITE_DEV_AUTH_BYPASS === 'true'

let app: FirebaseApp | null = null
let auth: Auth | null = null

if (!isDevBypass) {
  const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  }

  app = initializeApp(firebaseConfig)
  auth = getAuth(app)

  // Use localStorage persistence when configured (e.g. for e2e tests where
  // Playwright storageState captures localStorage but not IndexedDB).
  // Must be awaited before any sign-in to avoid a race with the default persistence.
  if (import.meta.env.VITE_FIREBASE_LOCAL_PERSISTENCE === 'true') {
    setPersistence(auth, browserLocalPersistence).catch((err) => {
      console.error('Failed to set Firebase auth persistence; falling back to default.', err)
    })
  }

  // Connect to emulator in development (optional)
  if (import.meta.env.DEV && import.meta.env.VITE_FIREBASE_USE_EMULATOR === 'true') {
    connectAuthEmulator(auth, 'http://localhost:9099')
  }
} else {
  console.log('🔧 Dev auth bypass enabled - Firebase SDK not initialized')
}

export { auth }
export default app
